<template>
  <div class="body-background" id="appg">
      <SiteNavigation/>
      <div v-if="alert.message" :class="`toast-alert alert ${alert.type}`">{{alert.message}}</div>
      <router-view />
      <AppVersion/>
  </div>
</template>

<script>
import SiteNavigation from './components/SiteNavigation';
import AppVersion from './components/AppVersion';
import { mapStores } from 'pinia';
import { useAlertStore } from '@/lib/store/alert.module';
import { useAuthStore } from '@/lib/store/authentication.module';
import { useUsersStore } from '@/lib/store/users.module';

export default {
  name: 'App',
  components: {
    SiteNavigation,
    AppVersion,
  },
  computed: {
    ...mapStores(useAlertStore),
    alert() {
      return this.alertStore;
    }
  },
  watch:{
    $route() {
      this.alertStore.clear();
    }
  },
  mounted() {
    this._storageHandler = (e) => {
      if (e.key !== 'user') return;
      if (e.newValue) {
        const authStore = useAuthStore();
        authStore.user = JSON.parse(e.newValue);
        authStore.status = { loggedIn: true };
        useUsersStore().fetchUserConfig();
        this.$router.push('/').catch(() => {});
      } else {
        const authStore = useAuthStore();
        authStore.status = {};
        authStore.user = null;
        const usersStore = useUsersStore();
        usersStore.permissions = null;
        usersStore.interfaceConfig = null;
        this.$router.push('/login').catch(() => {});
      }
    };
    window.addEventListener('storage', this._storageHandler);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this._storageHandler);
  },
  methods: {}
}
</script>

<style>
:root {
  --body-background: #212529;
  --errorColor: #ff4a46;
  --okColor: green;
  --lockOkColor: blue;
  --lockWarningColor: peru;
  --noSignal: gray;
  --warningColor: orange;
  --terminalColor:  #494e56;
  --activeTerminalColor:  #383e4a;
}
html, body, #app {
    height: 100%;
    background-color: var(--bs-body-bg);
    color: var(--bs-body-color);
}
.body-background {
  min-height: 100%;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
}
.tablebody {
  min-height: 100vh;
  background-color: var(--bs-body-bg);
  font-size: 13px  !important;
}
.form-control,
.mx-input {
  font-size: 13px !important;
}
.table td,
.table th {
  color: #adb5bd !important;
}
.toast-alert {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
  pointer-events: none;
}
</style>
